import $ from 'jquery';
import { $doc } from '../utils/globals';

if ($('.js-load-more').length) {
	$doc.on('click', '.js-load-more', function(e){
		e.preventDefault();

		const $ajaxContainer = $('.js-more-container');
		const $ajaxActions = $('.js-more-actions');

		$.ajax({
			url: $(this).attr('href'),
			beforeSend() {
				$ajaxContainer.addClass('is-loading');
			},
			success: function( response ) {
				$ajaxContainer.removeClass('is-loading');

				$ajaxContainer.append($(response).find('.js-more-container').html());

				if ($(response).find('.js-more-actions').length) {
					$ajaxActions.html($(response).find('.js-more-actions').html() );
				} else {
					$ajaxActions.remove();
				}
			},
			error() {
				$ajaxContainer.html('<h3>Error has occurred please try again!</h3>');
				$ajaxContainer.removeClass('is-loading');
			},
			always() {
				$ajaxContainer.removeClass('is-loading');
			}
		});
	})
}
